import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../assets/Main_Logo_AI_Colored_Padding.png"
// ✅ Styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 60,         // reserve room for footer
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  header: { fontSize: 18, marginBottom: 10, fontWeight: "bold", textAlign: "center", color: "rgb(0, 145, 70)" },
  section: { marginBottom: 10, paddingBottom: 5, borderBottom: "1px solid #ddd" },
  label: { fontWeight: "bold", fontSize: 14, marginBottom: 4 },
  text: { fontSize: 12, marginBottom: 5 },
  highlight: { backgroundColor: "#ffefeb", padding: 5, borderRadius: 5 },
  warning: { backgroundColor: "#fffde7", padding: 5, borderRadius: 5 },
  unnecessary: { backgroundColor: "#e3f2fd", padding: 5, borderRadius: 5 },
  bulletText: { fontSize: 12, marginBottom: 3, marginLeft: 10 },

  // ✅ Footer
  footer: {
    position: "absolute",
    bottom: 16,
    left: 20,
    right: 20,
    height: 24,
    borderTopWidth: 1,
    borderTopColor: "#e5e7eb",
    paddingTop: 6,
    fontSize: 9,
    color: "#6b7280",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  footerLeft: { fontSize: 9 },
  footerBrand: { flexDirection: "row", alignItems: "center", gap: 6 },
  logo: { width: 60, marginRight: 4 },
  brandText: { fontSize: 9, fontWeight: 700 },
});

// ✅ Reusable Component for Sections
const SectionList = ({ title, data, style }) => (
  <View style={[styles.section, style]}>
    <Text style={styles.label}>{title}</Text>
    {Array.isArray(data) && data.length > 0 ? (
      data.map((item, index) => (
        <View key={index} style={{ marginBottom: 8 }}>
          <Text style={styles.bulletText}>{`${item.section}`}</Text>
          <Text style={styles.text}><Text style={{ fontWeight: "bold" }}>Quote:</Text> {item.quote}</Text>
          <Text style={styles.text}><Text style={{ fontWeight: "bold" }}>Example:</Text> {item.example}</Text>
        </View>
      ))
    ) : (
      <Text style={styles.text}>None</Text>
    )}
  </View>
);

// ✅ Footer (fixed on every page)
const Footer = ({ generatedBy = "Portend AI", tag = "Confidential", brand = "Portend" }) => {
  const dateText = new Date().toLocaleDateString("en-US");
  return (
    <View style={styles.footer} fixed>
      <Text style={styles.footerLeft}>
        {`Generated by ${generatedBy} • ${tag} • ${dateText}`}
      </Text>
      <View style={styles.footerBrand}>
        {logo ? <Image style={styles.logo} src={logo} /> : null}
       
      </View>
    </View>
  );
};

// ✅ PDF Component
const PrivacyPolicyPDF = ({ data, pageTitle, footerDate, footerLogo }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.header}>{pageTitle}</Text>

      {/* Target Website */}
      <View style={styles.section}>
        <Text style={styles.label}>Target Website:</Text>
        <Text style={styles.text}>{data?.current_website_name}</Text>
      </View>

      {/* Company Name */}
      <View style={styles.section}>
        <Text style={styles.label}>Company:</Text>
        <Text style={styles.text}>{data?.current_company_name}</Text>
      </View>

      {/* Improper Sections */}
      <SectionList title="Improper Sections" data={data?.improper_sections} style={styles.highlight} />

      {/* Missing Sections */}
      <SectionList title="Missing Sections" data={data?.missing_sections} style={styles.warning} />

      {/* Unnecessary Parts */}
      <SectionList title="Unnecessary Parts" data={data?.unnecessary_part} style={styles.unnecessary} />

      {/* ✅ Sticky footer */}
      <Footer dateString={footerDate} logoSrc={footerLogo} />
    </Page>
  </Document>
);

export default PrivacyPolicyPDF;
